export class ProfileInfo {


    public CitizenID: string;
    public JurisID: number;

    public FirstName: string;
    public LastName: string;
    public MiddleName: string;
    public Email: string;
    public PrimaryNumber: string;
    public AlternateNumber: string;
    public Address1?: string;

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/profileinfo.model.ts